import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthContext } from "./context/AuthContext";
import MainPage from "./page/MainPage";
import ReservationPage from "./page/ReservationPage";
import ManagePage from "./page/management/ManagePage";
import FakePaymentPage from "./page/FakePaymentPage";
import CouponPage from "./page/CouponPage";
import StorePage from "./page/management/StorePage";
import RewardCardPage from "./page/RewardCardPage";
import ResetPasswordPage from "./page/ResetPasswordPage";
import ErrorBoundary from "./component/ErrorBoundary";
import TablePage from "./page/management/TablePage";
import PermissionPage from "./page/management/PermissionPage";
import { useState } from "react";
import "./css/App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import UserPage from "./page/management/UserPage";
import OrderResultPage from "./page/OrderResultPage";
import MyOrderPage from "./page/MyOrderPage";
import CMSCouponPage from "./page/management/coupon/CouponPage";
import NoticePage from "./page/NoticePage";
import ProfilePage from "./page/ProfilePage";
import LoginPage from "./page/management/LoginPage";
import WebPage from "./page/management/WebPage";
import ReportPage from "./page/management/ReportPage";
import OrderPage from "./page/management/OrderPage";
import NewsPage from "./page/management/NewsPage";
import InvoicePage from "./page/management/InvoicePage";
const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff", // white
    },
    secondary: {
      main: "#000000", // black
    },
    background: {
      default: "#f2f2f2",
    },
    text: {
      primary: "#000000",

      secondary: "grey",
      blue: "#007B7B",
      selected: "#ffffff",
    },
    appBar: "#332c2b",
    selected: "linear-gradient(180deg, #B4E9F9 1%, #007B7B 110%)",
    bonus: "#3E821C",
  },
  gradients: {
    primary: "linear-gradient(180deg, #B4E9F9 1%, #007B7B 110%)",
    secondary: "linear-gradient(180deg, #e3e3e3 1%, #666666 150%)",
  },
});

const isManageSubdomain = window.location.hostname.startsWith("console.");


const userRoutes = createRoutesFromElements([
  <Route>
    <Route path="/app" element={<MainPage />} />
    <Route path="/app/coupon" element={<CouponPage />} />
    <Route path="/app/rewardCard" element={<RewardCardPage />} />
    <Route path="/app/reservation" element={<ReservationPage />} />
    <Route path="/app/myOrder" element={<MyOrderPage />} />
    <Route path="/app/notice" element={<NoticePage />} />
    <Route path="/app/profile" element={<ProfilePage />} />
    <Route
      path="/app/paymentSimulation/:orderId"
      element={<FakePaymentPage />}
    />
    <Route
      path="/app/order/orderResult/:orderId"
      element={<OrderResultPage />}
    />
    <Route path="/rp/:token" element={<ResetPasswordPage />} />
  </Route>,
  <Route path="*" element={<Navigate to="/app" replace />} />,
]);
const adminRoutes = createRoutesFromElements([
  <Route path="/login" element={<LoginPage />} />,
  <Route path="/dashboard" element={<ManagePage />}>
    <Route path="web/setting" element={<WebPage />} />
    <Route path="web/news" element={<NewsPage />} />
    <Route path="store/new" element={<StorePage />} />
    <Route path="store/tables" element={<TablePage />} />
    <Route path="user/query" element={<UserPage />} />
    <Route path="order/query" element={<OrderPage />} />
    <Route path="invoice" element={<InvoicePage />} />
    <Route path="coupon/new" element={<CMSCouponPage />} />
    <Route path="permission" element={<PermissionPage />} />
    <Route path="report" element={<ReportPage />} />
  </Route>,
  <Route errorElement={<ErrorBoundary />} />,
]);
const router = createBrowserRouter(
  isManageSubdomain ? adminRoutes : userRoutes
);

function App() {
  const [user, setUser] = useState(null);
  const [pos, setPos] = useState(null);
  return (
    <ThemeProvider theme={theme}>
      <AuthContext.Provider
        value={{
          user: user,
          pos:pos,
          setUser: setUser,
          setPos:setPos
        }}
      >

          <RouterProvider router={router} />

      </AuthContext.Provider>
    </ThemeProvider>
  );
}

export default App;
